// common methods for slideshow/carousel implementations
// for composing new objects

import UI from '../core/ui'
import Transform from '../core/transform'

import Request from '../core/request'

import {
  flatten,
  compact,
  maybe
} from '../core/functions'

import {
  txt2dom2
} from '../core/utilities'

export function listPanels() {
  return this.dom.findByRole(this.options.panelRole)
}

export function getPanels() {
  if (this.panelsLoaded) {
    return
  }

  if (!this.options.url) {
    return
  }

  this.panelsLoaded = true

  const self = this
  const resolve = response => {
    let panels = txt2dom2(response)
    panels = panels.findByRole(self.options.panelRole)
    panels = compact(flatten(panels))

    // let panels2 = pipe([
    //     txt2dom2,
    //     panels => panels.findByRole(self.options.panelRole),
    //     panels => compact(flatten(panels))
    // ])(response)

    // this.log.warn(`getPanels: panels2:`, panels2)

    panels.forEach(p => {
      self.dom.appendChild(p)
      UI.evaluate(p)
    })

    if (self.lastHash && window.location.hash !== self.lastHash) {
      window.location.hash = self.lastHash
      // console.log(`changed location hash: #{window.location.hash}`)
    }
    self.initializePanels()

    if (self.options.autoplay) {
      self.resetAutoPlay()
    }
    // } catch (err) {
    //     this.log.error(err.message)
    //     this.log.error(err.stack)
    // }
  }

  const reject = err => {
    this.log.error('getPanels: error: ', err)
  }

  Request.post(this.options.url).then(resolve, reject)
}

export function initializeControls() {
  const panels = this.listPanels()

  this.controls = this.dom.findByRole('slideshow-nav')
  // const visibilityTimeout = 5000;
  const visibilityTimeout = 7500

  if (this.options.scrollonclick) {
    panels.forEach(p => {
      p.addEvent('click', () => {
        this.scrollLeft()
        this.resetAutoPlay()
      })
    })
  }

  if (this.options.hideControls) {
    if (panels.length < 2) {
      this.controls.forEach(c => {
        c.setStyles({
          visibility: 'hidden',
          display: 'none'
        })
      })
    }

    this.dom.addEvent('mouseover', () => {
      if (this.hiddenControls === false) {
        this.controls.forEach(c => {
          c.addClass('visible')
          this.controlTimeout = setTimeout(() => {
            c.removeClass('visible')
          }, visibilityTimeout)
        })
      }
    })
  }

  this.controls.forEach(c => {
    if (c.hasRole('slideshow-nav-next')) {
      c.addEvent('click', () => {
        this.scrollLeft()
        this.resetAutoPlay()
      })
    }

    if (c.hasRole('slideshow-nav-previous')) {
      c.addEvent('click', () => {
        this.scrollRight()
        this.resetAutoPlay()
      })
    }

    if (c.hasRole('slideshow-nav-pause')) {
      c.addEvent('click', () => {
        if (this.timer) {
          this.pauseSlideshow()
        } else {
          this.continueSlideshow()
        }
      })
    }
  })

  detectSwipeEvents(this.dom)

  this.dom.addEvent('swipe', ev => {
    switch (ev.detail.direction) {
    case 'left':
      this.scrollLeft()
      break

    case 'right':
      this.scrollRight()
      break
    }
  })

  if (this.options.usekeys) {
    document.addEventListener(
      'keydown',
      event => {
        if (event.control || event.shift) {
          return
        }
        if (!this.dom.isInViewport()) {
          return
        }

        switch (event.key) {
        case 'right':
        case 'ArrowRight':
          this.scrollLeft()
          this.resetAutoPlay()
          break
        case 'left':
        case 'ArrowLeft':
          this.scrollRight()
          this.resetAutoPlay()
          break
        case 'space':
        case ' ':
          if (this.timer) {
            this.pauseSlideshow && this.pauseSlideshow()
          } else {
            this.continueSlideshow && this.continueSlideshow()
          }
          break
        }
      },
      false
    )
  }
}

export function centerPanel(idx, removeClass) {
  const panels = this.listPanels()
  if (panels.length < 2) {
    return
  }
  this.movePanel(idx, removeClass, 0)
}

export function movePanel(idx, removeClass, amount) {
  if (this.paused) {
    return
  }

  const panels = this.listPanels()
  if (panels.length < 1) {
    return
  }
  if (removeClass === true) {
    panels[idx].removeClass('transition')
  } else {
    panels[idx].addClass('transition')
  }
  Transform.transform(panels[idx], Transform.translate3d(amount, 0, 0))
}

export function movePanelRight(idx, removeClass) {
  const panels = this.listPanels()

  if (idx >= panels.length) {
    idx = 0
  }
  this.movePanel(idx, removeClass, '100%')
}

export function movePanelLeft(idx, removeClass) {
  const panels = this.listPanels()

  if (idx < 0) {
    idx = panels.length - 1
  }
  this.movePanel(idx, removeClass, '-100%')
}

export function scroll(idx, direction, initializing) {
  const panels = this.listPanels()

  if (panels.length < 1) {
    return
  }

  if (idx >= panels.length) {
    if (this.dom.dataset.next) {
      this.redirect(this.dom.dataset.next)
      return
    }

    this.movePanelLeft(idx - 1)
    idx = 0
  }
  if (idx < 0) {
    if (this.dom.dataset.last) {
      this.redirect(this.dom.dataset.last)
      return
    }
    idx = panels.length - 1
  }
  this.centerPanel(idx)
  if (panels[idx].dataset.hash) {
    window.location.hash = panels[idx].dataset.hash
    // console.log(`changed location hash: #{window.location.hash}`)
  }

  if (direction === 'left') {
    this.movePanelLeft(idx - 1, initializing)
    this.movePanelRight(idx + 1, true)
  } else {
    this.movePanelLeft(idx - 1, true)
    this.movePanelRight(idx + 1, initializing)
  }
  this.selected = idx
}

// export function showSlide(idx) {
//     let panels = this.listPanels()

//     if (idx >= panels.length) {
//         idx = 0
//     }
//     if (idx < 0) {
//         idx = panels.length - 1
//     }
//     if (idx === this.selected) {
//         return
//     }

//     let p = panels[idx]
//     let oselected = this.selected
//     p.setStyle("opacity", 0)
//     this.centerPanel(idx, true)

//     p.set("tween", {
//         duration: 400,
//         transition: Fx.Transitions.Quad.easeInOut
//     })
//     p.tween("opacity", 1)

//     this.movePanelLeft(oselected, true)

//     this.movePanelLeft(idx - 1, true)
//     this.movePanelRight(idx + 1, true)

//     this.selected = idx
// }

export function scrollLeft(initializing) {
  const panels = this.listPanels()
  if (panels.length < 2) {
    return
  }
  this.scroll(this.selected + 1, 'left', initializing)
}

export function scrollRight(initializing) {
  const panels = this.listPanels()
  if (panels.length < 2) {
    return
  }
  this.scroll(this.selected - 1, 'right', initializing)
}

export function showNextSlide() {
  this.scrollLeft()
}

export function autoPlay(interval) {
  const panels = this.listPanels()
  if (panels.length < 2) {
    return
  }
  if (this.timer) {
    window.clearTimeout(this.timer)
  }
  if (!interval) {
    interval = this.options.interval
  }

  this.timer = setInterval(() => {
    this.showNextSlide()
  }, interval)
}

export function stopAutoPlay() {
  if (this.timer) {
    window.clearTimeout(this.timer)
  }
  return this.timer // may be undefined
}

export function resetAutoPlay() {
  if (this.options.autoplay) {
    if (this.timer) {
      window.clearTimeout(this.timer)
    }
    this.autoPlay()
  }
}

// modified from various sources, esp. http://www.javascriptkit.com/javatutors/touchevents2.shtml

export const detectSwipeEvents = touchsurface => {
  let startobj
  let startTime
  const threshold = 30 // required min distance traveled to be considered swipe
  const restraint = 150 // maximum distance allowed at the same time in perpendicular direction
  const allowedTime = 600 // maximum time allowed to travel that distance

  const isHorizontal = (x, y) =>
    Math.abs(x) >= threshold && Math.abs(y) <= restraint

  const isVertical = (x, y) =>
    Math.abs(y) >= threshold && Math.abs(x) <= restraint

  const getDirection = (x, y) => {
    let direction
    const elapsedTime = new Date().getTime() - startTime
    if (elapsedTime <= allowedTime) {
      if (isHorizontal(x, y)) {
        // if dist traveled is negative, it's a left swipe
        direction = x < 0 ? 'left' : 'right'
      } else if (isVertical(x, y)) {
        // if dist traveled is negative, it's an up swipe
        direction = y < 0 ? 'up' : 'down'
      }
    }
    return direction
  }

  const sendSwipeEvent = direction => {
    const swipeEvent = new CustomEvent('swipe', {
      detail: {
        direction
      },
      bubbles: true,
      cancelable: true
    })

    touchsurface.dispatchEvent(swipeEvent)
  }

  // below changed from addEventListener: test this
  // addEvent calls addEventListener with {passive: true}
  // see ui/core/patch.js

  touchsurface.addEvent(
    'touchstart',
    ev => {
      startobj = ev.changedTouches[0]
      startTime = new Date().getTime() // record time when finger first makes contact with surface
    }
    // false
  )

  touchsurface.addEvent(
    'touchmove',
    ev => ev.preventDefault() // prevent scrolling when inside element
    // false
  )

  touchsurface.addEvent(
    'touchend',
    ev => {
      const touchobj = ev.changedTouches[0]
      const x = touchobj.pageX - startobj.pageX // get horizontal distance traveled by finger
      const y = touchobj.pageY - startobj.pageY // get vertical distance traveled by finger

      maybe(sendSwipeEvent)(getDirection(x, y))
    }
    // false
  )
}
